import moment from 'moment';

const formatDateTime = (date) => moment(date).format('YYYY-MM-DD HH:mm');

export default formatDateTime;
